import React, { useEffect, useState } from "react";
import { Button, Card, Form, InputGroup, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Loader from "./Loader";
import Message from "./Message";
import SimpleToast from "./SimpleToast";
import { MdHelpOutline, MdZoomIn } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import MedicationDirectionForm from "./MedicationDirectionForm";

const VisitMedicationForm = ({
  deleteMedication,
  medication,
  tradeLabels,
  rosheta,
}) => {
  const [med, setMed] = useState(medication);
  const [direction, setDirection] = useState(medication.direction);
  const [show, setShow] = useState(false);

  useEffect(() => {
    medication.tradeId = med && med[0] ? med[0]._id : medication.tradeId;
    medication.tradeLabel =
      med && med[0] ? med[0].label : medication.tradeLabel;
    medication.direction = direction;
  }, [med, direction, rosheta]);

  return (
    <Card className="w-100 border-0 my-2">
      {!localStorage.tradeLabels || !tradeLabels ? (
        <>
          <Loader />
          <Message children={`Reload the page if any delay`} variant={`info`} />
        </>
      ) : (
        <div>
          <MedicationDirectionForm
            show={show}
            setShow={setShow}
            setDirection={setDirection}
            direction={direction}
            medication={medication}
          />
          <Row>
            <Form.Group className="col-12 col-lg-5">
              <>
                <SimpleToast
                  cell={
                    <Form.Label>
                      {`Medication `}
                      <MdHelpOutline className="text-xl text-gray-500 cursor-pointer relative -top-1" />
                    </Form.Label>
                  }
                  title="How to add new medication?"
                  body="Already we have a lot of medication, as you type any letter, medications will appear. In case of another medication: After typing medication name, click on New Selection. "
                />
              </>
              <Typeahead
                placeholder="Type Medication"
                options={tradeLabels}
                defaultInputValue={medication.tradeLabel}
                onChange={(e) => setMed(e)}
                id="med"
                allowNew // Enables the user to add custom values
              />
            </Form.Group>

            <Form.Group controlId="direction" className="col-12 col-lg-5">
              <Form.Label>Direction</Form.Label>

              <InputGroup>
                <Form.Control
                  placeholder="Type Direction"
                  type="text"
                  value={direction}
                  onChange={(e) => setDirection(e.target.value)}
                />

                <Button variant="outline-primary" onClick={() => setShow(true)}>
                  <MdZoomIn size={22} />
                </Button>
              </InputGroup>
            </Form.Group>

            <Form.Group className="col-12 col-lg-2 align-self-end text-center">
              <Button
                className="btn w-100 d-lg-inline-block"
                variant="outline-danger"
                onClick={() => deleteMedication(medication)}
              >
                <FaTrashAlt />
              </Button>
            </Form.Group>
          </Row>
        </div>
      )}
    </Card>
  );
};

export default VisitMedicationForm;
